<template>
  <b-table
    :fields="fields"
    :items="items"
    :busy="loading"
    responsive
    show-empty
    :empty-text="'Tidak ada data'"
  >
    <template #empty>
      <div class="text-center py-3">
        <div
          v-if="loading"
          ref="loadingFooter"
          class="d-flex justify-content-center align-items-center"
        >
          <b-spinner
            variant="primary"
            label="Loading..."
          />
          <span class="ml-2">Memuat data...</span>
        </div>
        <div
          v-else
          class="text-muted py-2"
        >
          Tidak ada data yang ditampilkan
        </div>
      </div>
    </template>
    <template #cell(order_date)="data">
      <!-- Tanggal Order -->
      <div>
        {{ DAY_WITH_FULL_DATE(data.value) }}
      </div>
      <div class="text-sm text-[#626262]">
        {{ TIME(data.value) }}
      </div>
    </template>
    <template #cell(total_orders)="data">
      <span>{{ data.item.total_orders_processed }}</span>/<span>{{ data.value }}</span>
    </template>
    <template #cell(status)="data">
      <StatusPackingPill :status="data.value" />
    </template>
    <template #cell(aksi)="data">
      <router-link
        class="text-[#08A0F7] hover:underline hover:text-[#08A0F7]"
        :to="{ name: 'detail-fulfillment-kompack', query: { ref_id: data.item.id } }"
      >
        Lihat Detail
      </router-link>
    </template>
  </b-table>
</template>

<script>
import { DAY_WITH_FULL_DATE, TIME } from '@/libs/formatDate'
import { fieldsHistoryPacking } from '../../config'
import StatusPackingPill from './StatusPackingPill.vue'

export default {
  components: {
    StatusPackingPill,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: fieldsHistoryPacking,
    }
  },
  methods: {
    DAY_WITH_FULL_DATE,
    TIME,
  },
}
</script>
